export default class ButtonImage extends Phaser.GameObjects.Container {
    constructor(scene, x, y, {width = 1, height = 1, image, hoverImage, hoverTint}) {
        super(scene, x, y, []);

        this.soundManager = scene.soundManager

        this.scene = scene;
        scene.add.existing(this);

        this.isLocked = false

        this.image = image
        this.hoverImage = hoverImage
        this.hoverTint = hoverTint

        this.addBody({width, height, image})        
        // Ajout intéractions
        this.setInteractive({useHandCursor: true});

        this.on('pointerover', () => {
            this.pointerOver()
        })

        this.on('pointerout', () => {
            this.pointerOut()
        })
    }

    setClickFunction( clickFunction ){
        this.removeListener('pointerup'); // Supprime les anciens listeners pour éviter les conflits
        this.on('pointerup', () => {
                this.soundManager.playOnce('Button3')
                this.scene.tweens.add({
                    targets: this,
                    scale: 0.9,
                    duration: 100,
                    yoyo: true,
                    ease: 'Cubic.easeInOut',
                    onComplete: () => {
                        clickFunction(this);
                    }
                })
        }, this.scene);
    }

    // -- A completer dans les class enfants

    addBody({width, height, image}){
        this.background = this.scene.add.image(0, 0, image).setOrigin(0.5);
        this.add(this.background);

        this.setSize(this.background.width, this.background.height);
    }

    pointerOver(){
        if(this.hoverImage)
            this.background.setTexture(this.hoverImage);

        if(this.hoverTint)
            this.background.setTint(this.hoverTint);
    }

    pointerOut(){
        if(this.hoverImage)
            this.background.setTexture(this.image);

        if(this.hoverTint)
            this.background.clearTint();
    }

    setLocked(){
        // Ajout de l'état bloqué
        this.isLocked = true
        this.disableInteractive();
        this.setAlpha(0.5); // Optionnel : rendre le bouton semi-transparent pour indiquer qu'il est bloqué
    }

    setUnlocked(){
        // Ajout de l'état débloqué
        this.isLocked = false
        this.setInteractive({useHandCursor: true});
        this.setAlpha(1); // Rendre le bouton complètement opaque
    }

    setFlipX(X){
        this.background.setFlipX(X);
    }

    setFlipY(Y){
        this.background.setFlipY(Y);
    }
}